import React, { useEffect, useState } from 'react'
import { Row, Col, Modal, Button} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import './ListCat.css'
import { CategoryTabLoading, ProdListLoading, TitleProdListLoading } from '../skeletonLoading/loadingTag'
import { fetchGetCategoryList1 } from '../../redux/ActionCreators/getCategoryList1Actions'
import { fetchGetCategoryList2 } from '../../redux/ActionCreators/getCategoryList2Actions'
import { fetchProductLists } from '../../redux/ActionCreators/productListActions'
import { useHistory, useParams } from 'react-router-dom'
import iconSort from '../../Asset/Icon/icon_sort.svg'
import sortAToZ from '../../Asset/Icon/icon_a_to_z.svg'
import sortZToA from '../../Asset/Icon/icon_z_to_a.svg'
import sortTerendah from '../../Asset/Icon/icon_harga_terendah.svg'
import sortTertinggi from '../../Asset/Icon/icon_harga_tertinggi.svg'
import AddCartModal from '../PopUpModal/HomePage/AddCartModal';
import productNotFound from '../../Asset/Icon/product_not_found.png'
import { nFormatter } from '../../function/helpers'

function Cat1() {

    const { catId } = useParams()
    const history = useHistory()
    const dispatch = useDispatch()
    const getCat1 = useSelector(state => state.getCategoryList1Reducer.getCategoryList1)
    const getCat2 = useSelector(state => state.getCategoryList2Reducer.getCategoryList2)
    const prodLists = useSelector(state => state.productListsReducer.prodLists)
    const isLoadingGetCatList1 = useSelector(state => state.isLoadingGetCatList1Reducer.isLoadingGetCatList1)
    const isLoadingGetCatList2 = useSelector(state => state.isLoadingGetCatList2Reducer.isLoadingGetCatList2)
    const isLoadingProductList1 = useSelector(state => state.isLoadingProductList1Reducer.isLoadingProductList1)
    const [catIdString, setCatIdString] = useState(catId.toString())
    const [scrollDown, setScrollDown] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [ visible, setVisible ] = useState(false);
    const [prodId, setProdId ] = useState(0);
    const [isOrder, setIsOrder] = useState(false)
    
    useEffect(() => {
        openModalWithData();
        dispatch( fetchGetCategoryList1(`{"layer_id": 0,"layer_key": ""}`, "/product/getcatandsubcatproduct") )
        dispatch( fetchGetCategoryList2(`{"layer_id": ${1},"layer_key": "${catId}"}`, "/product/getcatandsubcatproduct") )
        dispatch( fetchProductLists(`{
            "layer_id" : ${1},
            "layer_key":"${catId}",
            "sort_item":0,
            "page":1,
            "row_per_page":100
        }`, "/product/getproductlist") )

        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > 0) {
                setScrollDown(true)
            } else {
                setScrollDown(false)
            }
        };
        window.addEventListener("scroll", handleScroll);
    }, [dispatch])
    
    function convertToRupiah(money) {
        return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(money)
    }
    function handleClickLayer1(layerKey) {
        history.push(`/ProductListCategory/${layerKey}`)
        // window.location.reload();
    }

    async function handleClickLayer2(layerId1, layerKey1, layerId2, layerKey2) {
        history.push(`/ProdListCategory/cat_1=${layerKey1}&layer_1=${layerId1}&cat_2=${layerKey2}&layer_2=${layerId2}`)
        // window.location.reload();
    }
    
    const productDetail = (prodId, prodName) => {
        const productName = prodName;
        history.push({pathname: `/produk/${prodId}/${productName.replace(/\//g, " ")}`, state: {result: prodId, isFromList: true}})
    }

    function openModalWithData(id) {
        if(id === undefined){
            setIsOrder(false);
        }
        else
        {
            setIsOrder(true)
            const prodID = id;
            setProdId(prodID);
        }
    }

    function handleSortingProduct(sortItem, layerKey) {
        dispatch( fetchProductLists(`{
            "layer_id" : ${1},
            "layer_key":"${layerKey}",
            "sort_item":${sortItem},
            "page":1,
            "row_per_page":100
        }`, "/product/getproductlist") )
        setIsVisible(false)
    }

    function openModalWithData(id) {
        if(id === undefined){
            setVisible(false);
        }
        else
        {
            setVisible(true)
            const prodID = id;
            setProdId(prodID);
        }
    }
    
    const loops = [1,2,3,4,5,6]
    let activeCat = []
    let upperCat = []

    if (!isLoadingGetCatList1) {
        getCat1.forEach(category => {
            if(category.layer_key === catIdString) activeCat.push(category)
        })
        getCat1.forEach(category => {
            if(category.layer_key !== catIdString) upperCat.push(category)
        })
    }

    return (
        <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ marginTop: 58, overflowX: 'auto' }}>
                {
                    (isLoadingGetCatList1) ?
                    <CategoryTabLoading /> :
                    <table style={{ margin: '10px 10px 20px 10px', overflowX: 'scroll' }}>
                        <tbody>
                            <tr>
                                <td>
                                    <div onClick={() => (handleClickLayer1(activeCat[0].layer_key))} className="tab-produk no-select-text active_header">
                                        <img className="img-tab-active" src={ activeCat[0].img } alt="" />
                                        <span>{ activeCat[0].name }</span>
                                    </div>
                                </td>
                                {
                                    (upperCat) &&
                                    upperCat.map(kategori => {
                                        return(
                                            <td key={kategori.layer_key}>
                                                <div onClick={() => (handleClickLayer1(kategori.layer_key))} className="tab-produk no-select-text">
                                                    <img className="img-tab" src={ kategori.img } alt="" />
                                                    <span>{ kategori.name }</span>
                                                </div>
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        </tbody>
                    </table>
                }
            </div>
            <div style={{ marginTop: 20, marginLeft: 40, marginBottom: 10 }}>
                <div>
                    {
                        (isLoadingGetCatList1) ?
                        <TitleProdListLoading /> :
                        <span className="head-2">{ activeCat[0].name }</span>
                    }
                    {
                        (!scrollDown) ?
                        <div onClick={() => setIsVisible(!isVisible)} className='div-opt-btn' style={{position: 'relative',backgroundColor: 'unset', padding: 'unset', borderRadius: 'unset', border: 'unset', boxShadow: 'unset', marginRight: '10%', float: 'right'}}>
                            <img src={iconSort} alt='iconSort' style={{ cursor: 'pointer', marginTop: '2%', position: 'fixed'}} />
                        </div> :
                        <div onClick={() => setIsVisible(!isVisible)} className='div-opt-btn' style={{position : 'relative',backgroundColor: '#ffffff', padding: 5, borderRadius: 20, border: '1px solid rgb(238, 238, 238)', boxShadow: 'unset', marginRight: '10%', float: 'right' }}>
                            <img src={iconSort} alt='iconSort' style={{ cursor: 'pointer', display: 'block', position: 'fixed'}} />
                        </div>
                    }
                </div>
            </div>
            {
                (isLoadingGetCatList2) ?
                <CategoryTabLoading /> :
                (getCat2) &&
                <div style={{ marginTop: 18, overflowX: 'auto' }}>
                    <table style={{ margin: '0px 10px 10px 10px', overflowX: 'scroll' }}>
                        <tbody>
                            <tr>
                                {
                                    getCat2.map(kategori => {
                                        return (
                                            <td key={kategori.layer_key}>
                                                <div onClick={() => (handleClickLayer2(activeCat[0].layer_id, activeCat[0].layer_key, kategori.layer_id, kategori.layer_key))} className="tab-produk no-select-text">
                                                    <img className="img-tab" src={ kategori.img } alt="" />
                                                    <span>{ kategori.name }</span>
                                                </div>
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
            <div style={{ marginTop: 25 }}>
                {
                    (isLoadingProductList1) ?
                    <Row style={{ justifyContent: 'space-around' }}>
                        {
                            loops.map(loop => {
                                return (
                                    <ProdListLoading key={loop} />
                                )
                            })
                        }
                    </Row> :
                    (prodLists.length === 0) ?
                    <Row style={{ justifyContent: 'center', marginTop: -10 }}>
                        <div>
                            <img src={productNotFound} alt="" width="70px" height="66px" />
                        </div>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <div>
                                <label style={{ fontSize: 20, fontWeight: 600 }}>
                                    <p>Mereka akan segera hadir di ezeePasar.</p>
                                </label>
                            </div>
                            <div style={{ marginTop: -16 }}>
                                <span className="text-1">
                                    Coba kata kunci lain atau cek produk rekomendasi di bawah
                                </span>
                            </div>
                        </Col>
                    </Row> :
                    <Row>
                        {
                            prodLists.map((prodList, i) => {
                                return (
                                    <Col key={i} span={10} className="item-product-list" style={{ marginLeft: 20, marginBottom: 15, width: '46%', float: 'left' }}>
                                        <div onClick={() => productDetail(prodList.product_id, prodList.product_name)} className="box-produk" style={{ width: '100%', position: 'relative' }}>
                                            {
                                                (prodList.product_stat_stock_id === 2) ?
                                                <>
                                                    <img src={ prodList.product_image } alt="" className='imgProduct'/>
                                                    <div className="sold-out" style={{ marginLeft: -11, marginTop: -11, height: '78%', width: '113%' }}></div>
                                                    <div className="sold-out-text" style={{ marginTop: -140, marginLeft: 70, marginBottom: 65 }}>Habis</div>
                                                    {/* <div className='sold-out-cat'>
                                                        <img src={prodList.product_image} alt="" className='imgProduct' />
                                                        <span className='sold-out-cat-text'>Habis</span>
                                                    </div>  */}
                                                </> :
                                                <img src={ prodList.product_image } alt="" className='imgProduct' />
                                            }
                                            <div className="text-2" style={{ marginTop: 12 }}>
                                                <div className="text-produk1" style={{ fontSize: 13 }}>
                                                    { prodList.product_name }
                                                </div>
                                                <div className="text-produk2">
                                                    { prodList.product_weight } { prodList.product_weight_name }
                                                </div>
                                                {
                                                    (prodList.product_promo_percent == null) ?
                                                    <p className="text-produk3">{ convertToRupiah(prodList.product_price) } / { prodList.product_unit_name }</p> :
                                                    <>
                                                        <div className="disc-product">
                                                            <span className="percent-disc">{ prodList.product_promo_percent }%</span>
                                                            <span className="real-price">{ convertToRupiah(prodList.product_price) }</span>
                                                        </div>
                                                        <p className="text-produk3">{ convertToRupiah(prodList.product_promo_price) } / { prodList.product_unit_name }</p>
                                                    </>
                                                }
                                                {
                                                    prodList.product_terjual !== null && prodList.product_terjual !== 0 ? 
                                                    <div>
                                                        <span className='sp-danger product-sold-and-stock' style={{fontSize: 10, float: 'left'}}>Terjual: <span style={{color: 'black'}}>{nFormatter(prodList.product_terjual)}</span></span>
                                                    </div> : null
                                                }
                                                {/* {
                                                    (prodList.product_stat_stock_id === 2) ?
                                                    <div onClick={(event) => event.stopPropagation()}><Button className="btn-pesan-sold" shape="round" disabled>Pesan</Button></div>
                                                    : <div onClick={(event) => event.stopPropagation()}><Button className="btn-pesan" shape="round" onClick={() =>openModalWithData(prodList.product_id)}>Pesan</Button></div>
                                                } */}
                                            </div>
                                        </div>
                                        {
                                            (prodList.product_stat_stock_id === 2) ?
                                            <button className="btn-pesan-sold" style={{ cursor: 'default !important' }}>Pesan</button> :
                                            <button className="btn-pesan" onClick={() =>openModalWithData(prodList.product_id)}>Pesan</button>
                                        }
                                    </Col>
                                )
                            })
                        }
                    </Row>
                }
            </div>
            {
                visible ? <AddCartModal showModal={visible} setModal={setVisible} closedModal={() => setVisible(false)} productId={prodId}/> : null
            }
            <Modal
                visible={isVisible}
                onCancel={() => setIsVisible(false)}
                footer={null}
                className={(!scrollDown) ? "modalVefiedFilterProd" : "modalVefiedFilterProd"}
            >
                <div className='div-sort-item' style={!scrollDown ? {display: 'unset', marginTop: '25%', marginRight: '-6%', cursor: 'pointer'} : {display: 'unset', marginTop: '20%', marginRight: '-4%', cursor: 'pointer'}}>
                    <img onClick={() => handleSortingProduct(1, catId)} style={{ width: 82, height: 32 }} src={sortAToZ} alt='aToZ' />
                    <img onClick={() => handleSortingProduct(2, catId)} style={{ width: 82, height: 32 }} src={sortZToA} alt='zToA' />
                    <img onClick={() => handleSortingProduct(3, catId)} style={{ width: 82, height: 32 }} src={sortTerendah} alt='terendah' />
                    <img onClick={() => handleSortingProduct(4, catId)} style={{ width: 82, height: 32 }} src={sortTertinggi} alt='tertinggi' />
                </div>
            </Modal>
            {
                isOrder ? <AddCartModal showModal={isOrder} setModal={setIsOrder} closedModal={() => setIsOrder(false)} productId={prodId}/> : null
            }
        </div>
    )
}

export default Cat1
